// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


// @ts-ignore
import { SnomedCodeResponse } from './snomed-code-response';

/** See com.rev360.pms.api.controller.encounter.history.mentalstatus.MentalStatusResponse */
/* istanbul ignore next */
@GandalfModel
export class MentalStatusResponse extends GandalfModelBase {

	@GandalfProperty({ propertyType: 'LocalDate', designType: Date })
	dateOfOnset!: Date | null;

	@GandalfProperty({ designType: String })
	disabilityStatusComments!: string | null;

	@GandalfProperty({ designType: SnomedCodeResponse })
	disabilityStatusSnomedCode!: SnomedCodeResponse | null;

	@GandalfProperty({ designType: String })
	functionalStatusComments!: string | null;

	@GandalfProperty({ designType: SnomedCodeResponse })
	functionalStatusSnomedCode!: SnomedCodeResponse | null;

	@GandalfProperty({ designType: Number })
	id!: number | null;

	@GandalfProperty({ designType: String })
	mentalStatusComments!: string | null;

	@GandalfProperty({ designType: SnomedCodeResponse })
	mentalStatusSnomedCode!: SnomedCodeResponse | null;

	@GandalfConstantDecorator(constants.Mood)
	@GandalfProperty({ designType: constants.Mood })
	mood!: constants.Mood | null;

	@GandalfProperty({ designType: String })
	moodComments!: string | null;

	@GandalfConstantDecorator(constants.Orientation)
	@GandalfProperty({ designType: constants.Orientation })
	orientation!: constants.Orientation | null;

	@GandalfProperty({ designType: String })
	orientationComments!: string | null;

	@GandalfProperty({ designType: Number })
	version!: number | null;

}
